<template>
  <div>
    <ul class="study-set-overview-list">
      <li v-for="studySet in assignedStudySets" :key="studySet.id" class="study-set-overview-row-wrapper">
        <el-row type="flex" :gutter="0" class="study-set-overview">
          <el-col :span="2" class="flex justify-center study-set-overview-row-toogle-button">
            <font-awesome-icon
              :icon="!isStudySetShowDetail(studySet.id) ? 'chevron-down' : 'chevron-up'"
              @click="toggleShowDetailStudySets(studySet.id)"
            />
          </el-col>
          <el-col :span="6">
            <p class="study-set-name">{{ studySet.name }}</p>
          </el-col>
          <el-col :span="6">
            <p>
              <span class="label">{{ $t("read_aloud.overview.type") }}: </span>
              <span class="value">{{ $t("study_sets.study_set") }}</span>
            </p>
          </el-col>
          <el-col :span="3">
            <p>
              <span class="label">{{ $t("common.items") }}: </span>
              <span class="value">{{ studySet.phrases_count }}</span>
            </p>
          </el-col>
          <el-col :span="5">
            <p>
              <span class="label">{{ $t("read_aloud.overview.created_by") }}: </span>
              <span class="value">{{ assignedReadAloud.owner_name }}</span>
            </p>
          </el-col>
          <el-col :span="2" class="flex justify-center">
            <el-button @click="removeStudySet(studySet.id)" class="remove-study-set">
              <font-awesome-icon
                :icon="['fas', 'trash-alt']"
                style="color: #eb5757; font-size: 14px; line-height: 14px"
              />
            </el-button>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="isStudySetShowDetail(studySet.id)" class="phrases-wrapper">
            <ul class="phrases-list">
              <li v-for="phrase in showPhraseOfStudySet(studySet)" :key="phrase">
                <el-row type="flex" :gutter="24" width="100%">
                  <el-col :offset="1" :span="24">
                    {{ phrase }}
                  </el-col>
                </el-row>
              </li>
            </ul>
          </div>
        </el-collapse-transition>
      </li>
      <li class="study-set-overview-row-wrapper">
        <el-row type="flex" :gutter="0" class="study-set-overview">
          <el-col :span="2" class="flex justify-center study-set-overview-row-toogle-button">
            <font-awesome-icon
              :icon="!showRADetail ? 'chevron-down' : 'chevron-up'"
              @click="showRADetail = !showRADetail"
            />
          </el-col>
          <el-col :span="6">
            <p class="study-set-name">{{ assignedReadAloud.name }}</p>
          </el-col>
          <el-col :span="6">
            <p>
              <span class="label">{{ $t("read_aloud.overview.type") }}: </span>
              <span class="value">{{ $t("read_aloud.overview.reading_aloud") }}</span>
            </p>
          </el-col>
          <el-col :span="3">
            <p>
              <span class="label">{{ $t("read_aloud.overview.words") }}: </span>
              <span class="value">{{ wordCount(assignedReadAloud.passage) }}</span>
            </p>
          </el-col>
          <el-col :span="5">
            <p>
              <span class="label">{{ $t("read_aloud.overview.created_by") }}: </span>
              <span class="value">{{ assignedReadAloud.owner_name }}</span>
            </p>
          </el-col>
          <el-col :span="2" class="flex justify-center"></el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="showRADetail" class="passage-wrapper">
            {{ assignedReadAloud.passage }}
          </div>
        </el-collapse-transition>
      </li>
      <li v-if="assignedStudySets.length == 0">
        <el-row type="flex" :gutter="24" class="study-set-overview">
          <el-col :span="24">
            <el-button @click="handleAddWarmUpSS" class="btn-add-study-set">
              <font-awesome-icon :icon="['fas', 'plus']" class="pr-px-8" />
              {{ $t("read_aloud.modals.addAssignment.add_warm_up") }}
            </el-button>
          </el-col>
        </el-row>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DefaultCategoryOptions } from "@/constants/studySets";
import { getOptionsLabels } from "@/utils/elementUi";
import { pathOr } from "ramda";

export default {
  props: {},
  data() {
    return {
      showDetailStudySets: [],
      showRADetail: false
    };
  },
  computed: {
    ...mapGetters({
      buildingAssignments: "readAlouds/getBuildingAssignments",
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    assignedStudySets() {
      return pathOr([], ["buildingAssignments", "studySets"])(this);
    },
    assignedStudySetIds() {
      if (this.assignedStudySets.length > 0) {
        return this.assignedStudySets.map(x => x.id);
      }
      return []
    },
    assignedReadAloud() {
      return pathOr([], ["buildingAssignments", "readAloud"])(this);
    },
  },
  methods: {
    ...mapActions({
      updateBuildingAssignments: "readAlouds/updateBuildingAssignments",
    }),
    getCategoryLabel(v) {
      return getOptionsLabels(DefaultCategoryOptions, v);
    },
    isStudySetShowDetail(id) {
      return this.showDetailStudySets.includes(id);
    },
    toggleShowDetailStudySets(id) {
      if (this.showDetailStudySets.includes(id)) {
        this.showDetailStudySets = this.showDetailStudySets.filter(x => x != id);
      } else {
        this.showDetailStudySets.push(id);
      }
    },
    showPhraseOfStudySet(studySet) {
      if (!studySet || !studySet.phrases) {
        return 0;
      }
      return studySet.phrases;
    },
    removeStudySet(id) {
      this.updateBuildingAssignments({
        studySets: this.assignedStudySets.filter(x => x.id != id),
      });
    },
    handleAddWarmUpSS() {
      const assignedStudySets = this.assignedStudySets;
      assignedStudySets.push(this.assignedReadAloud.warm_up_ss);
      this.updateBuildingAssignments({
        studySets: assignedStudySets,
      });
    },
    handleAddSelectStudySet(selectedStudySet) {
      const assignedStudySets = this.assignedStudySets;
      for (let i = 0; i < selectedStudySet.length; i++) {
        if (assignedStudySets.every(x => x.id != selectedStudySet[i].id)) {
          assignedStudySets.push(selectedStudySet[i]);
        }
      }
      this.updateBuildingAssignments({
        studySets: assignedStudySets,
      });
    },
    wordCount(passage) {
      if (typeof passage !== 'string') {
        return 0;
      }

      const wordsArray = passage.match(/\b\w+\b/g);
      return wordsArray ? wordsArray.length : 0
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/_colors.scss";
ul {
  list-style-type: none;
  padding-left: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
}
.study-set-overview-list {
  .study-set-overview-row-wrapper {
    box-shadow: inset 0px -1px 0px #e6e6e6;
    background: white;
    cursor: move;
  }

  > :last-child {
    margin-bottom: 0px;
    box-shadow: none;
  }

  .study-set-overview-row-toogle-button {
    cursor: pointer;
  }
}
.study-set-overview {
  font-size: 14px;
  height: 64px;
  align-items: center;
  .study-set-name {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin-top: 0px;
    margin-bottom: 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: $black;
    text-align: initial;
    font-weight: 400;
  }

  .value {
    color: $black;
    text-transform: none;
    font-weight: 600;
  }
}
.btn-add-study-set {
  min-width: 150px;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 8px 16px;
  color: $black;
  font-family: "SF Pro Display";
  margin-left: 12px;
}

.remove-study-set {
  width: 40px;
  height: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.phrases-wrapper {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px 0px;
}

.passage-wrapper {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px;
}

.phrases-list {
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 0;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    // box-shadow: inset 0 0 8px #C2C2C2;
    border-radius: 100px;
  }

  > :last-child {
    margin-bottom: 0px;
    box-shadow: none;
  }

  .el-row {
    width: 100%;
  }
}
.phrases-list li {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: $black;
  margin-bottom: 16px;
  display: flex;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb !important;
}
.label {
  text-transform: capitalize;
}
</style>
